module.exports = "<h2 id=customizing-text>Customizing text</h2> <p>Tangram is powerful because it let&#39;s you customize the drawing style of your layers to suit your needs. There are many more parameters you can use to customize your labels. Take a look at a few below:</p> <p>[section] { &quot;type&quot;: &quot;tangram&quot;, &quot;src&quot;: &quot;labels3.yaml&quot;, &quot;lines&quot;: &quot;28-45&quot; } [section]</p>";


/*****************
 ** WEBPACK FOOTER
 ** ./Assets/markdown/styling5.md
 ** module id = 691
 ** module chunks = 1
 **/